__turbopack_context__.v({
  "bestByFieldItem": "DatePicker-module-scss-module__VaKoZa__bestByFieldItem",
  "bestByFields": "DatePicker-module-scss-module__VaKoZa__bestByFields",
  "inputWrapper": "DatePicker-module-scss-module__VaKoZa__inputWrapper",
  "isDefault": "DatePicker-module-scss-module__VaKoZa__isDefault",
  "root": "DatePicker-module-scss-module__VaKoZa__root",
  "select": "DatePicker-module-scss-module__VaKoZa__select",
});
